import React, { useContext, useEffect, useMemo, useRef } from "react";

import { AppContext } from "../App";
import Products from "./Products";
import ProductsOnePage from "./ProductsOnePage";
import Menu from "./Menu";

function Categories() {
  const {
    settings,
    shop,
    list,
    course,
    setCourse,
    category,
    setCategory,
    products,
    setProducts,
    courses,
    setCourses,
    menu,
    menuVisible,
    getTranslatedString,
  } = useContext(AppContext);
  const categoriesScrollRef = useRef(null);
  const categoryButtonsRef = useRef({});
  const enableCategoriesView = settings?.menu?.enable_categories_view == 1;
  const productsLoadingType = String(settings?.menu?.products_loading_type ?? "").toLowerCase();
  const isOnePageMode = ["onepage", "one_page", "singlepage", "single_page", "1", "true"].includes(
    productsLoadingType,
  );

  const { normalizedCourses, hasUncategorizedBucket } = useMemo(() => {
    if (!courses || courses.length === 0) {
      return { normalizedCourses: [], hasUncategorizedBucket: false };
    }

    const mappedCourses = [];
    const uncategorizedCategories = [];

    for (const currentCourse of courses) {
      const hasCourseId =
        currentCourse &&
        currentCourse.id !== null &&
        currentCourse.id !== undefined &&
        currentCourse.id !== "" &&
        currentCourse.id !== 0 &&
        currentCourse.id !== "0";

      if (!hasCourseId) {
        if (currentCourse.categories && currentCourse.categories.length > 0) {
          uncategorizedCategories.push(...currentCourse.categories);
        }
      } else {
        mappedCourses.push(currentCourse);
      }
    }

    if (mappedCourses.length > 0 && uncategorizedCategories.length > 0) {
      mappedCourses.push({
        id: "uncategorized-auto",
        name: "Altro",
        categories: uncategorizedCategories,
      });
    }

    if (mappedCourses.length === 0) {
      return { normalizedCourses: courses, hasUncategorizedBucket: false };
    }

    return {
      normalizedCourses: mappedCourses,
      hasUncategorizedBucket: uncategorizedCategories.length > 0,
    };
  }, [courses]);

  const hasMacroCategories = normalizedCourses && normalizedCourses.length > 1;
  const visibleCourses = hasMacroCategories ? (course ? [course] : []) : normalizedCourses;
  const showAllCategoriesInTopMenu = settings?.menu?.categories_menu_type == 2;
  const categoriesMenuCourses = showAllCategoriesInTopMenu
    ? normalizedCourses
    : enableCategoriesView
      ? visibleCourses
      : normalizedCourses;
  const firstAvailableCategory = useMemo(() => {
    for (const c of normalizedCourses) {
      if (c.categories && c.categories.length > 0) return c.categories[0];
    }
    return false;
  }, [normalizedCourses]);

  useEffect(() => {
    if (menu) filterMenu();
  }, [list, shop, menu, settings]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    console.log("category set to", category);
    if (category && (category.scroll || settings.menu.categories_menu_type != 2)) {
      const element = document.getElementById("category-" + category.id);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
    if (!category) {
      setProducts([]);
      return;
    }
    setProducts(category.products || []);
  }, [category]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    console.log("menu set to", menu);
  }, [menu]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    console.log("courses set to", courses);
    if (course) {
      if (course.id == "uncategorized-auto") {
        if (!hasUncategorizedBucket) setCourse(false);
        return;
      }
      const selectedCourse = normalizedCourses.find((el) => el.id == course.id);
      if (!selectedCourse) setCourse(false);
      else if (selectedCourse !== course) setCourse(selectedCourse);
    }
    if (!hasMacroCategories && course) setCourse(false);
    if (!enableCategoriesView && course) setCourse(false);
  }, [courses, normalizedCourses, hasUncategorizedBucket]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!enableCategoriesView) return;
    if (!course || category) return;
    if (!course.categories || course.categories.length !== 1) return;

    const onlyCategory = course.categories[0];
    if (isOnePageMode) {
      setCategory({ ...onlyCategory, scroll: true });
    } else {
      setCategory(onlyCategory);
    }
  }, [course, category, settings]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (enableCategoriesView) return;
    if (!shop || !list) return;
    if (category) return;
    if (!firstAvailableCategory) return;
    if (isOnePageMode) {
      setCategory({ ...firstAvailableCategory, scroll: true });
    } else {
      setCategory(firstAvailableCategory);
    }
  }, [enableCategoriesView, shop, list, category, firstAvailableCategory, settings]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!category) return;
    if (!settings || settings.menu.categories_menu_type != 2) return;
    const container = categoriesScrollRef.current;
    const button = categoryButtonsRef.current[category.id];
    if (!container || !button) return;

    container.scrollTo({
      left: button.offsetLeft,
      behavior: "smooth",
    });
  }, [category, settings]);

  const getCategoryImage = (item) => {
    return item.img || item.image || item.settings?.img || item.settings?.image;
  };

  const getItemName = (item) => {
    if (item?.id === "uncategorized-auto") return "Altro";
    return getTranslatedString(item, "name") || item?.name || "Altro";
  };
  const showSideMenu = settings?.menu?.categories_menu_type == 1 && menuVisible;

  function filterMenu() {
    console.log("filterMenu");
    let res = [];
    for (const course of menu) {
      const cr = structuredClone(course);
      cr.categories = [];
      for (const category of course.categories) {
        if (category.active_menu == 0) continue;
        const ct = structuredClone(category);
        if (shop && list != "none") {
          ct.products = [];
          for (const product of category.products) {
            let pr = filterVariants(product);
            const priceList = product.prices.filter((el) => {
              return el.list_id == list.id && el.price;
            });
            const assortment = product.assortment.filter((el) => {
              return el.shop_id == shop.id && el.list_id == list.id && el.active == 1;
            });
            if (priceList.length > 0 && assortment.length > 0 && checkIngredientsAssortment(product)) {
              pr.price = priceList[0].price;
              ct.products.push(pr);
            }
          }
          if (ct.products.length > 0) cr.categories.push(ct);
        } else if (shop && list == "none") {
          ct.products = [];
          for (const product of category.products) {
            let pr = filterVariants(product);
            if (checkIngredientsAssortment(product)) {
              ct.products.push(pr);
            }
          }
          if (ct.products.length > 0) cr.categories.push(ct);
        } else {
          if (category.products.length > 0) cr.categories.push(category);
        }
      }
      if (cr.categories.length > 0) res.push(cr);
    }
    setCourses(res);
  }

  const filterVariants = (product) => {
    let p = JSON.parse(JSON.stringify(product));
    p.variants_categories = [];
    for (const variants_category of product.variants_categories) {
      let vc = JSON.parse(JSON.stringify(variants_category));
      vc.variants = [];
      vc.variants2 = [];
      vc.products = [];
      vc.products2 = [];
      for (const variant of variants_category.variants) {
        let v = JSON.parse(JSON.stringify(variant));
        if (shop && list != "none") {
          const priceList = variant.prices.filter((el) => {
            return el.list_id == list.id && el.price !== null;
          });
          const assortment = variant.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == list.id && el.active == 1;
          });
          if (priceList.length > 0 && assortment.length > 0) {
            v.price = priceList[0].price;
            vc.variants.push(v);
          }
        } else {
          vc.variants.push(v);
        }
      }
      for (const variant of variants_category.variants2) {
        let v = JSON.parse(JSON.stringify(variant));
        if (shop && list != "none") {
          const priceList = variant.prices.filter((el) => {
            return el.list_id == list.id && el.price !== null;
          });
          const assortment = variant.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == list.id && el.active == 1;
          });
          if (priceList.length > 0 && assortment.length > 0) {
            v.price = priceList[0].price;
            vc.variants2.push(v);
          }
        } else {
          vc.variants2.push(v);
        }
      }
      for (const subproduct of variants_category.products) {
        let sp = JSON.parse(JSON.stringify(subproduct));
        if (shop && list != "none") {
          const priceList = subproduct.prices.filter((el) => {
            return el.list_id == list.id && el.price !== null;
          });
          const assortment = subproduct.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == list.id && el.active == 1;
          });
          if (priceList.length > 0 && assortment.length > 0 && checkIngredientsAssortment(subproduct)) {
            sp.price = priceList[0].price;
            vc.products.push(sp);
          }
        } else if (shop && list == "none") {
          if (checkIngredientsAssortment(subproduct)) {
            vc.products.push(sp);
          }
        } else {
          vc.products.push(sp);
        }
      }
      for (const subproduct of variants_category.products2) {
        let sp = JSON.parse(JSON.stringify(subproduct));
        if (shop && list != "none") {
          const priceList = subproduct.prices.filter((el) => {
            return el.list_id == list.id && el.price !== null;
          });
          const assortment = subproduct.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == list.id && el.active == 1;
          });
          if (priceList.length > 0 && assortment.length > 0 && checkIngredientsAssortment(subproduct)) {
            sp.price = priceList[0].price;
            vc.products2.push(sp);
          }
        } else if (shop && list == "none") {
          if (checkIngredientsAssortment(subproduct)) {
            vc.products2.push(sp);
          }
        } else {
          vc.products2.push(sp);
        }
      }
      if (
        vc.variants.length > 0 ||
        vc.variants2.length > 0 ||
        vc.products.length > 0 ||
        vc.products2.length > 0
      )
        p.variants_categories.push(vc);
    }
    return p;
  };

  const checkIngredientsAssortment = (product) => {
    if (!settings.menu_api) return true;
    if (!settings.menu_api.enable_ingredients_assortment) return true;
    if (settings.menu_api.enable_ingredients_assortment != 1) return true;
    if (!product.ingredients) return true;
    if (product.ingredients.length == 0) return true;
    for (const ingredient of product.ingredients) {
      const assortment = ingredient.assortment.filter((el) => {
        return el.shop_id == shop.id && el.active == 1;
      });
      if (assortment.length == 0) return false;
    }
    return true;
  };

  return (
    <>
      {shop &&
        list &&
        settings.menu.categories_menu_type == 2 &&
        (showAllCategoriesInTopMenu || !enableCategoriesView || !hasMacroCategories || course) && (
          <div className="menu-categories-2">
            <div className="scroll-content" ref={categoriesScrollRef}>
              {categoriesMenuCourses &&
                categoriesMenuCourses.map((course, n) =>
                  course.categories.map((listCategory, i) => (
                    <button
                      key={i}
                      ref={(el) => {
                        if (el) categoryButtonsRef.current[listCategory.id] = el;
                      }}
                      onClick={() => {
                        if (settings.menu.categories_menu_type == 2 && isOnePageMode) {
                          if (category) {
                            const element = document.getElementById("category-" + listCategory.id);
                            if (element)
                              element.scrollIntoView({
                                behavior: "smooth",
                              });
                          } else {
                            setCategory({ ...listCategory, scroll: true });
                          }
                        } else {
                          setCategory(listCategory);
                        }
                      }}
                      className={listCategory.id == category.id ? "active" : ""}
                    >
                      {getTranslatedString(listCategory, "name")}
                    </button>
                  )),
                )}
            </div>
          </div>
        )}
      {enableCategoriesView && shop && list && !category && hasMacroCategories && !course && (
        <div className="main main-shell">
          {showSideMenu && <Menu />}
          <div className="main-content categories-overview">
            <div className="categories-grid">
              {courses &&
                normalizedCourses.map((macro, i) => {
                  const macroImage = getCategoryImage(macro);
                  return (
                    <button
                      key={i}
                      className={"category-item" + (!macroImage ? " no-image" : "")}
                      onClick={() => {
                        setCourse(macro);
                      }}
                    >
                      {macroImage && (
                        <div className="image">
                          <img src={macroImage} alt={getItemName(macro)} />
                        </div>
                      )}
                      <div className="name">{getItemName(macro)}</div>
                    </button>
                  );
                })}
            </div>
          </div>
        </div>
      )}
      {enableCategoriesView && shop && list && !category && (!hasMacroCategories || course) && (
        <div className="main main-shell">
          {showSideMenu && <Menu />}
          <div className="main-content categories-overview">
            {visibleCourses &&
              visibleCourses.map((course, i) => (
                <div key={i} className="course-box">
                  {hasMacroCategories && course.name && (
                    <h3 className="course-title">{getTranslatedString(course, "name")}</h3>
                  )}
                  <div className="categories-grid">
                    {course.categories.map((listCategory, n) => {
                      const categoryImage = getCategoryImage(listCategory);
                      return (
                        <button
                          key={n}
                          className={"category-item" + (!categoryImage ? " no-image" : "")}
                          onClick={() => {
                            if (isOnePageMode) {
                              setCategory({
                                ...listCategory,
                                scroll: true,
                              });
                            } else {
                              setCategory(listCategory);
                            }
                          }}
                        >
                          {categoryImage && (
                            <div className="image">
                              <img src={categoryImage} alt={getTranslatedString(listCategory, "name")} />
                            </div>
                          )}
                          <div className="name">{getTranslatedString(listCategory, "name")}</div>
                        </button>
                      );
                    })}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
      {shop && list && category && (
        <div className="main main-shell">
          {showSideMenu && <Menu />}
          <div id="main" className="main-content">
            {isOnePageMode ? <ProductsOnePage /> : <Products products={products} category={category} />}
          </div>
        </div>
      )}
    </>
  );
}

export default Categories;
